import { DatePicker } from '@ui-framework/index';
import { forwardRef, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

const EndDate = forwardRef((props, ref) => {
  const { control, setValue } = useFormContext();
  const startDate = useWatch({
    control,
    name: 'effectiveStartDate',
  });
  const endDate = useWatch({
    control,
    name: 'effectiveEndDate',
  });

  useEffect(() => {
    if (!startDate) {
      setValue('endDate', null);
    } else if (dayjs(startDate) >= dayjs(endDate)) {
      setValue('endDate', null);
    }
  }, [startDate, endDate]);

  let minDate = dayjs(startDate).add(1, 'day');
  if (startDate) {
    if (dayjs(startDate).isBefore(new Date(), 'day')) {
      minDate = dayjs(new Date());
    }
  }

  const disabled = props?.disabled ? props?.disabled : !startDate;

  let helperText = '';
  if (disabled) {
    helperText = (
      <FormattedMessage
        id="PLEASE_SELECT_START_DATE_TO_ENABLE_THIS_FIELD"
        defaultMessage="Please select a start date to enable this field"
      />
    );
  } else if (endDate) {
    helperText = (
      <FormattedMessage
        id="AVAILABILITY_POST_END_DATE_MESSAGE"
        defaultMessage="When the Effective End Date is reached, availability will automatically revert to the schedule configured above it."
      />
    );
  } else {
    helperText = (
      <FormattedMessage
        id="AVAILABILITY_INDEFINITE_PERIOD_MESSAGE"
        defaultMessage="Leave blank if this schedule should remain active indefinitely."
      />
    );
  }

  return (
    <DatePicker
      ref={ref}
      name="endDate"
      {...props}
      disabled={disabled}
      {...(startDate && { minDate })}
      {...{
        slotProps: {
          textField: {
            helperText,
          },
        },
      }}
    />
  );
});

export default EndDate;
